import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=7871a71e"
import script from "./Validate.vue?vue&type=script&lang=ts"
export * from "./Validate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports